/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as TabsDefault } from './tabs-default.story';
export { default as TabsFillVariants } from './tabs-fill-variants.story';
export { default as TabsSizes } from './tabs-sizes.story';
export { default as TabsWithIcons } from './tabs-with-icons.story';
export { default as TabsDisabled } from './tabs-disabled.story';
export { default as TabsOverflow } from './tabs-overflow.story';
export { default as TabsBadge } from './tabs-badge.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import TabsBadgeSourceRaw from './tabs-badge.story?raw';
import TabsDefaultSourceRaw from './tabs-default.story?raw';
import TabsDisabledSourceRaw from './tabs-disabled.story?raw';
import TabsFillVariantsSourceRaw from './tabs-fill-variants.story?raw';
import TabsOverflowSourceRaw from './tabs-overflow.story?raw';
import TabsSizesSourceRaw from './tabs-sizes.story?raw';
import TabsWithIconsSourceRaw from './tabs-with-icons.story?raw';

export const TabsDefaultSource = removeLicenseHeader(TabsDefaultSourceRaw);
export const TabsFillVariantsSource = removeLicenseHeader(
  TabsFillVariantsSourceRaw,
);
export const TabsSizesSource = removeLicenseHeader(TabsSizesSourceRaw);
export const TabsWithIconsSource = removeLicenseHeader(TabsWithIconsSourceRaw);
export const TabsDisabledSource = removeLicenseHeader(TabsDisabledSourceRaw);
export const TabsOverflowSource = removeLicenseHeader(TabsOverflowSourceRaw);
export const TabsBadgeSource = removeLicenseHeader(TabsBadgeSourceRaw);
